export function ErrorPage() {
    return (<h1 id="error">Page Not Found !</h1>)
}